import React from "react";
import { useForm, Controller } from "react-hook-form";

const TagForm = ({
  onSubmitHandler,
  buttonText = "Create",
  defaultValues = {},
}) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      ...defaultValues,
    },
  });

  const onSubmit = (data) => {
    onSubmitHandler(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700">
          Tag Name
        </label>
        <Controller
          name="name"
          control={control}
          rules={{ required: "Tag name is required" }}
          render={({ field }) => (
            <input
              type="text"
              {...field}
              className={`mt-1 block w-full border-gray-300 rounded-md shadow-sm ${
                errors.name ? "border-red-500" : ""
              }`}
            />
          )}
        />
        {errors.name && (
          <p className="text-red-500 text-sm">{errors.name.message}</p>
        )}
      </div>
      <button
        type="submit"
        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
      >
        {buttonText}
      </button>
    </form>
  );
};

export default TagForm;
